import React from 'react';

const UserDashboard = ({ children }) => {
  return <>{children}</>;
};

export default UserDashboard;
